import { ROUTES } from '@constants/index'

const KEY = {
  ALLOW_DIRECT_NAVIGATION: 'direct-billing.allow-direct-navigation',
  LOGIN_REDIRECT_PARAM: 'direct-billing.loginRedirect', // NOTE: this is used by commerce F/E, DO  NOT change the key
  BASE_PATH: 'direct-billing.base-path',
  BASE_PATH_SEARCH: 'direct-billing.base-path-search',
  LAST_PATH: 'direct-billing.last-path',
} as const

export const isAllowDirectNavigation = (): boolean => {
  return (
    window.sessionStorage.getItem(KEY.ALLOW_DIRECT_NAVIGATION) === 'true' ||
    window.location.pathname.indexOf(ROUTES.LOGIN_REDIRECT) !== -1
  )
}

export const setAllowDirectNavigation = () => {
  window.sessionStorage.setItem(KEY.ALLOW_DIRECT_NAVIGATION, 'true')
}

export const clearAllowDirectNavigation = () => {
  window.sessionStorage.removeItem(KEY.ALLOW_DIRECT_NAVIGATION)
}

export const setLoginRedirectParam = (options: { basePath: string; signInPath: string }) => {
  // locale = fr-fr
  const { basePath, signInPath } = options

  const locale = signInPath.split('/')?.[1]
  const base = basePath.replace(`/${locale}`, '')
  const param = `${base}${ROUTES.BASE}/${ROUTES.LOGIN_REDIRECT}`

  window.sessionStorage.setItem(KEY.LOGIN_REDIRECT_PARAM, param)
}

export const clearLoginRedirectParam = () => {
  window.sessionStorage.removeItem(KEY.LOGIN_REDIRECT_PARAM)
}

export const setLocalBasePath = () => {
  window.sessionStorage.setItem(KEY.BASE_PATH, `${window.location.pathname}${window.location.search}`)
  window.sessionStorage.setItem(KEY.BASE_PATH_SEARCH, window.location.search)
}

export const getLocalBasePath = (): string => {
  return window.sessionStorage.getItem(KEY.BASE_PATH) ?? ''
}

export const getLocalBasePathSearch = (): string => {
  return window.sessionStorage.getItem(KEY.BASE_PATH_SEARCH) ?? ''
}

export const clearLocalBasePath = () => {
  window.sessionStorage.removeItem(KEY.BASE_PATH)
  window.sessionStorage.removeItem(KEY.BASE_PATH_SEARCH)
  window.sessionStorage.removeItem(KEY.LAST_PATH)
}

export const setLocalLastPath = (path: string) => {
  window.sessionStorage.setItem(KEY.LAST_PATH, path)
}

export const getLocalLastPath = (): string => {
  return window.sessionStorage.getItem(KEY.LAST_PATH) ?? ''
}

export const isLocationAllowedToProceed = (): boolean => {
  return (
    (window.location.pathname === getLocalLastPath() &&
      !window.location.pathname.endsWith(ROUTES.ERROR) &&
      !window.location.pathname.endsWith(ROUTES.LOADING)) ||
    window.location.pathname.endsWith(ROUTES.START)
  )
}

const RESUMABLE_PATHS = [
  ROUTES.INSURANCE_INFORMATION,
  ROUTES.SELECT_PRESCRIPTION,
  ROUTES.SELECT_PRODUCT,
  ROUTES.VALIDATE_PRESCRIPTION,
  ROUTES.REVIEW_CLAIM,
  ROUTES.QUOTE,
]

export const shouldNavigateToResume = (): boolean => {
  const pathname = window.location.pathname
  const hasResumePath = RESUMABLE_PATHS.find(path => pathname.endsWith(path))
  return hasResumePath !== undefined
}
